import { isSuperAdminRole, matchesRoleAllowList } from '@/utils/roles';

/** Staff roles with API access to `pmx_early_ops` (plus injected READ_ONLY). */
export const EARLY_HUB_ALLOWED_ROLES = [
  'SUPER_ADMIN',
  'SUPER_DOCTOR',
  'ADMIN',
  'CLINICAL_SUPPORT',
  'OPERATIONS_SUPPORT',
  'HEALTH_COACH',
  'RECEPTION',
  'DOCTOR',
  'RELATIONSHIP_MANAGER',
  'PHARMACIST',
  'NURSE',
  'THERAPIST',
  'READ_ONLY',
] as const;

export const canAccessEarlyHub = (role: string | null | undefined) =>
  isSuperAdminRole(role) || matchesRoleAllowList(role, EARLY_HUB_ALLOWED_ROLES);

export const STAGE = {
  BLOOD: 1,
  THRIVE: 2,
  COGNITIVE: 3,
  SNAPSHOT: 4,
  UNLOCK: 5,
  SUPPLEMENTS: 6,
  FIRST_CONSULT: 7,
  RETEST: 8,
  RETEST_SNAPSHOT: 9,
  SECOND_CONSULT: 10,
  PLAN_COMPLETE: 11,
} as const;

export const ROSTER_STAGE_FILTERS = [
  '1 Blood work',
  '2 Thrive check',
  '3 Cognitive test',
  '4 Snapshot & plan',
  '5 App unlock',
  '6 Supplements',
  '7 1st consultation',
  '8 Retest + recheck',
  '9 Retest snapshot',
  '10 2nd consultation',
  '11 Plan complete',
] as const;

export const ROSTER_STATUS_FILTERS = [
  'On track',
  'Waiting on client',
  'Waiting on PMX',
  'At risk',
  'Blocked',
  'Done',
] as const;

export const PARTNER_LABS = [
  'Thyrocare',
  'Tata 1mg Labs',
  'Metropolis',
  'Dr Lal PathLabs',
  'Redcliffe Labs',
  'Apollo Diagnostics',
  'PMX in-house (HQ)',
] as const;

export const SEARCH_DEBOUNCE_MS = 300;
export const NOTE_MAX_LENGTH = 4000;
export const SIGNOFF_NAME_MAX_LENGTH = 120;

export const EARLY_HUB_ROSTER_QUERY_OPTIONS = {
  staleTime: 60_000,
  gcTime: 10 * 60_000,
  retry: 1,
  refetchOnWindowFocus: false,
} as const;

export const EARLY_HUB_JOURNEY_QUERY_OPTIONS = {
  staleTime: 30_000,
  gcTime: 10 * 60_000,
  retry: 1,
  refetchOnWindowFocus: false,
} as const;
